import { useEffect } from "react";
import { GUIDES } from "./data";
import { setPageMeta } from "../../lib/pageMeta";

const PAGE_TITLE = "Dispute Resolution Guides | CaseThread";
const PAGE_DESCRIPTION =
  "Free, practical guides on resolving disputes with banks, insurers, landlords, and regulators. From CaseThread.";

export default function GuidesIndexPage() {
  useEffect(() => {
    setPageMeta({
      title: PAGE_TITLE,
      description: PAGE_DESCRIPTION,
      canonical: "https://casethread.app/guides",
    });
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  return (
    <div className="guides-page">
      <header className="guides-header">
        <a href="/welcome" className="guides-brand">
          <img
            src="/casethread-icon.png?v=2"
            alt=""
            width={28}
            height={28}
            className="guides-brand-icon"
          />
          <span>CaseThread</span>
        </a>
        <nav aria-label="Header">
          <a href="/welcome">Home</a>
        </nav>
      </header>

      <main className="guides-main">
        <div className="guides-intro">
          <h1>Dispute resolution guides</h1>
          <p className="guides-intro-sub">
            Practical, step-by-step guides for resolving disputes with banks,
            insurers, landlords, and regulators. Free to read, no sign-up.
          </p>
        </div>

        <ul className="guides-list">
          {GUIDES.map((g) => (
            <li key={g.slug} className="guides-card">
              <h2 className="guides-card-title">
                <a href={`/guides/${g.slug}`}>{g.title}</a>
              </h2>
              <p className="guides-card-summary">{g.summary}</p>
              <a
                href={`/guides/${g.slug}`}
                className="guides-card-cta"
                aria-label={`Read: ${g.title}`}
              >
                Read the guide →
              </a>
            </li>
          ))}
        </ul>
      </main>

      <footer className="guides-footer">
        <div className="guides-footer-inner">
          <span className="guides-footer-brand">© 2026 CaseThread</span>
          <nav aria-label="Footer">
            <a href="/welcome">About</a>
            <span aria-hidden> · </span>
            <a href="/privacy">Privacy</a>
            <span aria-hidden> · </span>
            <a href="/terms">Terms</a>
            <span aria-hidden> · </span>
            <a href="/changelog">Changelog</a>
            <span aria-hidden> · </span>
            <a href="mailto:hello@casethread.app">Contact</a>
          </nav>
        </div>
      </footer>
    </div>
  );
}
